import { render, staticRenderFns } from "./MSubTitle1.vue?vue&type=template&id=095b0e66&scoped=true&"
import script from "./MSubTitle1.vue?vue&type=script&lang=js&"
export * from "./MSubTitle1.vue?vue&type=script&lang=js&"
import style0 from "./MSubTitle1.vue?vue&type=style&index=0&id=095b0e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095b0e66",
  null
  
)

export default component.exports